import React, { useContext, useState, useCallback } from 'react';

import useComponentMounted from '../../../../../../../hooks/useComponentMounted';
import useLogger from '../../../../../../../hooks/useLogger';
import { CoachingActivity } from '../../../../../../../utils/log';
import ExternalCoachContext from '../../../../../../context/ExternalCoachContext';
import useToast from '../../../../../../hooks/useToast';
import RadioButtonGroup from '../../../../../../components/RadioButtonGroup';
import { SettingOption } from '../utils';
import {
  SettingContainer as Container,
  HeaderContainer,
  SettingsActionContainer,
  TitleContainer,
  Title,
  SubTitle,
  ActionLabel,
} from '../styles';

import texts from './texts.json';

const AnnouncementSettings = () => {
  const {
    coachDoc,
    coachDoc: {
      announcementNotificationsEnabled,
    },
  } = useContext(ExternalCoachContext);

  const { showToast } = useToast();
  const isComponentMountedRef = useComponentMounted();
  const { logCoachingActivity } = useLogger();

  const [announcementNotificationSettings, setAnnouncementNotificationSettings] = useState(
    announcementNotificationsEnabled ? SettingOption.ENABLED : SettingOption.DISABLED,
  );

  const handleAnnouncementNotificationSettingsChange = useCallback(
    async (value) => {
      try {
        setAnnouncementNotificationSettings(value);

        await coachDoc.updateAnnouncementNotificationSettings(value === SettingOption.ENABLED);
        logCoachingActivity(CoachingActivity.UPDATED_ANNOUNCEMENT_NOTIFICATION_SETTINGS);
        if (isComponentMountedRef.current) {
          showToast(texts.announcementSettingSaveSuccessful);
        }
      } catch (error) {
        showToast(texts.error, { error: true });
      }
    },
    [coachDoc, isComponentMountedRef, showToast, logCoachingActivity],
  );

  return (
    <Container>
      <HeaderContainer>
        <TitleContainer>
          <Title>{texts.title}</Title>
          <SubTitle>{texts.announcementDescription}</SubTitle>
        </TitleContainer>
      </HeaderContainer>
      <SettingsActionContainer>
        <ActionLabel>{texts.announcementNotification}</ActionLabel>
        <RadioButtonGroup
          options={[
            {
              label: texts.enabled,
              value: SettingOption.ENABLED,
            },
            {
              label: texts.disabled,
              value: SettingOption.DISABLED,
            },
          ]}
          selectedOption={announcementNotificationSettings}
          onOptionChange={(value) => handleAnnouncementNotificationSettingsChange(value)}
        />
      </SettingsActionContainer>
    </Container>
  );
};

export default AnnouncementSettings;
